import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  initials: string;
  color: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  name: 'Marco Bianchi',
  role: 'Allenatore U16 — Milano',
  initials: 'MB',
  color: 'from-blue-500/30 to-blue-700/10',
  quote: 'Prima passavo ore a preparare gli allenamenti. Con VOLLEY PRONTO ora bastano 5 minuti e ho recuperato i miei weekend. Le ragazze sono migliorate visibilmente in poche settimane.'
}, {
  name: 'Giulia Romano',
  role: 'Coach Prima Squadra — Bologna',
  initials: 'GR',
  color: 'from-amber-500/30 to-amber-700/10',
  quote: 'Il kit più completo che abbia mai usato. Esercizi chiari, progressioni logiche e programmazioni già pronte. Lo consiglio a qualunque allenatore voglia smettere di improvvisare.'
}, {
  name: 'Luca Ferrari',
  role: 'Allenatore Settore Giovanile — Roma',
  initials: 'LF',
  color: 'from-emerald-500/30 to-emerald-700/10',
  quote: 'Investimento ripagato dopo il primo allenamento. La qualità del materiale è da professionisti e i miei atleti sono finalmente concentrati e motivati.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-20 px-4" data-id="element-221">
      <div className="max-w-6xl mx-auto" data-id="element-222">
        <div className="text-center mb-10 sm:mb-14" data-id="element-223">
          <span className="inline-block bg-secondary/10 border border-secondary/20 text-secondary font-bold text-xs px-3 py-1.5 rounded-full mb-4" data-id="element-224">
            ⭐ COSA DICONO GLI ALLENATORI
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-225">
            Oltre 800 coach hanno già{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-226">
              trasformato
            </span>{' '}
            i loro allenamenti
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto font-medium" data-id="element-227">
            Storie reali di allenatori che hanno scelto VOLLEY PRONTO.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-228">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-229">
              <div className="flex items-center gap-1 text-secondary text-lg" aria-label="5 stelle su 5" data-id="element-230">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium flex-1" data-id="element-231">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-232">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${t.color} border-2 border-primary/30 flex items-center justify-center flex-shrink-0`} aria-hidden="true" data-id="element-233">
                  <span className="text-text-main font-black text-sm tracking-wide" data-id="element-234">
                    {t.initials}
                  </span>
                </div>
                <div data-id="element-235">
                  <p className="text-text-main font-bold text-sm" data-id="element-236">{t.name}</p>
                  <p className="text-text-sec text-xs font-medium" data-id="element-237">{t.role}</p>
                </div>
                <span className="ml-auto text-check-green text-xs font-bold flex items-center gap-1" title="Acquisto verificato" data-id="element-238">
                  ✓ Verificato
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}